<template>
    <div>
        <b-form-group
            label="Question"
            label-for="question"
        >
            <TipTap
                v-model="editable_content.question"
                :class="{'is-invalid': validating && !editable_content.question}"
                :menu_items="['bold', 'italic', 'underline', 'bullet_list', 'ordered_list', 'image', 'edit_html']"
                @input="setContent('question', $event)"
            />

            <b-form-invalid-feedback :state="validating && !editable_content.question ? false : null">
                Question is required
            </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
            label="Answer"
            label-for="answer"
        >
            <b-form-select
                v-model="editable_content.answer"
                :state="validating && !editable_content.answer ? false : null"
            >
                <b-form-select-option value="true">
                    True
                </b-form-select-option>
                <b-form-select-option value="false">
                    False
                </b-form-select-option>
            </b-form-select>

            <b-form-invalid-feedback :state="validating && !editable_content.answer ? false : null">
                Answer is required
            </b-form-invalid-feedback>
        </b-form-group>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import { mapState } from 'vuex'


export default {
    data: () => ({
        editable_content: {}
    }),
    props: [
        'question'
    ],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap')
    },
    computed: {
        ...mapState({
            validating: state => state.utilities.validating
        })
    },
    watch: {
        question: {
            handler (question) {
                if (
                    question &&
                    question.content
                ) {
                    this.editable_content = question.content
                }
            },
            deep: true,
            immediate: true
        },
        editable_content: {
            handler (editable_content) {
                if (editable_content) {
                    this.$set(this.question, 'content', editable_content)
                }
            },
            deep: true
        }
    },
    methods: {
        setContent (field, value) {
            this.$set(this.editable_content, field, value)
        }
    }
}
</script>
